import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'

export default function DeleteFile(props) {
  const { data, open, handleClose, onSubmit, loading } = props
  return (
    <DialogComponent
      open={open}
      handleclose={loading ? null : handleClose}
      widthLarge="500px"
      disableChildHeight
      title="¿Desea eliminar esta archivo?"
      actions={
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <CancelConfirmButtons
            onClickCancel={() => handleClose()}
            onClickSubmit={() => onSubmit(data.data, data.index)}
            isLoading={loading}
            disabledCancel={loading}
            disabledSubmit={loading}
          />
        </div>
      }
    />
  )
}
